<div class="modal-unit {{ modal.classList }}" [style]="'max-width:' + modal.width + 'px;'">
  <p class="title" *ngIf="modal.title" [innerHTML]="modal.title"></p>

  <button
    *ngIf="modal.hasCloseButton"
    attr.aria-label="{{ 'modalItems.close' | translate }}"
    class="bg-transparent border-0 box-close"
    (click)="close()"
    data-testid="closeModal"
  >
    <modal-close size="16"></modal-close>
  </button>

  <div class="box-content">
    <ng-template #dynamicContainer></ng-template>
  </div>
</div>
